module.exports = __webpack_public_path__ + "static/media/frc-summer-2022-image-2.a1bb12b8.png";